import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { BaasAppState, BaasAuthService } from '@lvflanders/bar';
import { BarCoreService } from '@lvflanders/bar-ng';

/** Widget injected into burgerprofiel header in case impersonating (tech page). */
@Component({
    templateUrl: './bar-impersonation-widget.component.html'
})
export class BarImpersonationWidgetComponent implements OnInit {
    readonly #auth = inject(BaasAuthService);
    readonly #state = inject(BaasAppState);
    readonly #coreState = inject(BarCoreService);
    readonly #destroyRef = inject(DestroyRef);

    protected content = signal<string>(this.#state.basiscontext?.fullUsername);

    ngOnInit() {
        this.#coreState.basiscontextChanged.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((basiscontext) => {
            this.content.set(basiscontext?.fullUsername);
        });
    }

    protected logOff(): void {
        this.#auth.logOff();
    }
}
